import debounce from 'lodash.debounce'

let breakpoints = {
  xs: [-Infinity, 320],
  s: [320, 480],
  m: [480, 768],
  l: [768, 1024],
  xl: [1024, 1366],
  xxl: [1366, Infinity]
}

const resizeSubscribers = []

const getViewportWidth = () => window.document.documentElement.clientWidth

const getCurrentBreakpointNames = () => {
  const currentBreakpointNames = []
  const screenWidth = getViewportWidth()

  for (const key in breakpoints) {
    const min = breakpoints[key][0]
    const max = breakpoints[key][1]

    if (screenWidth >= min && screenWidth < max) {
      currentBreakpointNames.push(key)
    }
  }

  return currentBreakpointNames
}

export default {
  subscribe(subscriber, newBreakpoints) {
    breakpoints = { ...breakpoints, ...newBreakpoints }

    if (subscriber && typeof subscriber === 'function') {
      resizeSubscribers.push(subscriber)
    }

    window.addEventListener(
      'resize',
      debounce(() => {
        resizeSubscribers.forEach(func =>
          func({
            viewportWidth: getViewportWidth(),
            breakpointNames: getCurrentBreakpointNames()
          })
        )
      }, 300)
    )

    resizeSubscribers.forEach(func =>
      func({
        viewportWidth: getViewportWidth(),
        breakpointNames: getCurrentBreakpointNames()
      })
    )
  },
  addBreakpoints(newBreakpoints) {
    if (
      !newBreakpoints ||
        typeof newBreakpoints !== 'object' ||
        !Object.keys(newBreakpoints).length
    ) { return }

    breakpoints = { ...breakpoints, ...newBreakpoints }
  },
  removeBreakpoints(breakpointsToRemove) {
    if (!breakpointsToRemove || !Array.isArray(breakpointsToRemove) || !breakpointsToRemove.length) {
      return
    }

    breakpointsToRemove.forEach((name) => {
      if (breakpoints[name]) {
        delete breakpoints[name]
      }
    })
  }
}
